import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { bool, func } from 'prop-types';
import PortalModal from '../../components/common/Modal/PortalModal';
import GenericButton from '../../components/common/GenericButton';
import CommonDropdown from '../../components/common/CommonDropdown';
import {
  CA_ADD_CONTRACT_STATUS_OPTIONS,
  CA_ADD_CONTRACT_DEFAULT_STATUS_OPTIONS,
  CA_MODAL_STATIC_TEXT,
} from '../../constants';

const modalStyles = {
  left: '40%',
  top: '30%',
  width: '450px',
  height: '600px,',
};
const headerStyles = {
  padding: '16px',
  height: '54px',
  fontSize: '16px',
};
const closeButtonStyle = {
  display: 'none',
};

const BulkStatusUpdateModal = ({
  showBulkStatusUpdateModal,
  onCancelClicked,
}) => {
  const [defaultActiveDropdown, setDefaultActiveDropdown] = useState(
    CA_ADD_CONTRACT_DEFAULT_STATUS_OPTIONS
  );
  const [statusDate, setStatusDate] = useState('');
  const [validationError, setValidationError] = useState('');
  const handleCancel = () => {
    setDefaultActiveDropdown(CA_ADD_CONTRACT_DEFAULT_STATUS_OPTIONS);
    onCancelClicked();
  };
  const dropdownClickFn = dropDownValue => {
    setDefaultActiveDropdown(dropDownValue);
    setStatusDate('');
    setValidationError('');
  };
  const handleStatusDateChange = date => {
    setStatusDate(date ? moment(date).format('MM/DD/YY') : '');
    setValidationError('');
  };
  const handleSave = () => {
    if (
      (defaultActiveDropdown.value === 'H' ||
        defaultActiveDropdown.value === 'D') &&
      statusDate === ''
    ) {
      setValidationError('A date is required to proceed.');
    }
  };
  return (
    <PortalModal
      isShowing={showBulkStatusUpdateModal}
      title="Change Status"
      dialogStyles={modalStyles}
      onCloseClicked={handleCancel}
      headerStyles={headerStyles}
      closeButtonStyle={closeButtonStyle}
    >
      <span className="ca-status-change-modal-static-text">
        {CA_MODAL_STATIC_TEXT}
      </span>
      <div className="ca-status-change-modal-inputs">
        <div className="ca-status-change-modal-dropdown" title="Status">
          <CommonDropdown
            placeHolder="Status"
            itemClickFn={e => dropdownClickFn(e)}
            listData={CA_ADD_CONTRACT_STATUS_OPTIONS}
            defaultSelected={defaultActiveDropdown}
            title="status"
          />
        </div>
        {defaultActiveDropdown.value === 'A' && (
          <input
            id="status"
            name="status"
            className="ca-status-change-modal-date-picker"
            placeholder="On Hold/Disabled"
            title="On Hold/Disabled"
            type="text"
            disabled
          />
        )}
        {(defaultActiveDropdown.value === 'H' ||
          defaultActiveDropdown.value === 'D') && (
          <DatePicker
            selected={statusDate ? new Date(statusDate) : statusDate}
            placeholderText={
              defaultActiveDropdown.value === 'H' ? ' On Hold' : 'Disabled'
            }
            title={
              defaultActiveDropdown.value === 'H' ? ' On Hold' : 'Disabled'
            }
            onChange={handleStatusDateChange}
            dropdownMode="select"
            className="ca-status-change-modal-date-picker"
          />
        )}
      </div>
      <div className="modal-footer">
        {validationError && (
          <span className="ca-status-change-modal-validation-error">
            {validationError}
          </span>
        )}
        <GenericButton
          name="Cancel"
          btnStyle="ca-status-change-modal-cancel-button"
          onBtnClick={handleCancel}
        />
        <GenericButton
          name="Save"
          btnStyle="ca-status-change-modal-save-button"
          onBtnClick={handleSave}
        />
      </div>
    </PortalModal>
  );
};
BulkStatusUpdateModal.propTypes = {
  showBulkStatusUpdateModal: bool,
  onCancelClicked: func,
};
export default BulkStatusUpdateModal;
